/* Specialista Daily — Verifica adattabilità con targa (scheda prodotto)
 * Config via window.SD_VT (iniettata dal blocco liquid):
 *   { workerUrl, productHandle, variantId, price, modelImages:{gen:url}, hsPortal, hsForm }
 * Regola d'oro: il "NO" del DB NON è affidabile -> non diciamo MAI "incompatibile";
 *   compatibile SOLO se il prodotto è nella lista del veicolo, altrimenti "da verificare".
 */
(function () {
  var CFG = window.SD_VT || {};
  var root = document.querySelector('.svt');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  // Il tema mette il blocco custom in una cella grid che collassa: riposiziono il
  // widget nella colonna d'acquisto, subito sotto l'add-to-cart (dove c'è spazio).
  (function relocate() {
    var add = document.querySelector('.product-form__add-button');
    var host = add && (add.closest('.product-block-list__item') || add.closest('.product-form').parentElement);
    if (host && root.parentElement !== host) { host.appendChild(root); }
  })();

  // Batch UX: forza il riempimento navy dell'add-to-cart (il tema lo tiene outline con CSS più
  // specifico) → stile inline !important, che vince su qualsiasi foglio di stile.
  (function fillCTA() {
    var apply = function () {
      document.querySelectorAll('.product-form__add-button').forEach(function (b) {
        if (b.closest('.svt')) return; // non toccare il bottone del riquadro verifica
        b.style.setProperty('background-color', '#192747', 'important');
        b.style.setProperty('color', '#fff', 'important');
        b.style.setProperty('border-color', '#192747', 'important');
        b.querySelectorAll('svg, svg *').forEach(function (s) { s.style.setProperty('stroke', '#fff', 'important'); });
      });
    };
    apply(); setTimeout(apply, 500);
  })();

  // Mobile: dopo aver rimpicciolito la galleria via CSS, Flickity resta con la geometria
  // vecchia (immagine scentrata) → forziamo un ricalcolo con un evento resize.
  (function galleryKick() {
    if (!window.matchMedia || !window.matchMedia('(max-width:749px)').matches) return;
    var kick = function () { window.dispatchEvent(new Event('resize')); };
    window.addEventListener('load', kick);
    document.querySelectorAll('.product-gallery__image').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', kick, { once: true });
    });
    setTimeout(kick, 400);
  })();


  var KEY = 'sd_vehicle';           // { value, kind:'targa'|'telaio', descr }
  var lastValue = '';               // ultimo valore verificato (per prefill form)
  var WORKER = (CFG.workerUrl || 'https://telaio-sd.operations-kefa.workers.dev').replace(/\/$/, '');
  var HANDLE = (CFG.productHandle || '').toLowerCase();
  var PID = String(CFG.productId || '');   // id prodotto: match stabile fra store IT/esteri (lo slug URL è tradotto, l'id no)
  var GA4_ID = (CFG.ga4Id || 'G-5W5ZS6GMS8');   // property GA4 SD: gtag broadcast NON la raggiunge → invio esplicito con send_to
  var CB_URL = (CFG.callbackUrl || 'https://callback-sd.operations-kefa.workers.dev'); // Worker richiamata immediata

  /* ---------- evento "ogni warn" → SOLO worker callback-sd (D1 warn_events), MAI GA4/Ads.
     PII-safe: targa/telaio solo come hash one-way; vehicle_descr/motore/cbv = configurazione condivisa. ---------- */
  var OE = CFG.oe || '', SKU = CFG.sku || '', CATEGORY = CFG.category || '';
  var LANG = CFG.lang || (document.documentElement.lang || '');
  function deviceType() { return (window.matchMedia && window.matchMedia('(max-width:749px)').matches) ? 'mobile' : 'desktop'; }
  var SID_KEY = 'sd_warn_sid';
  function warnSessionId() {
    try {
      var s = sessionStorage.getItem(SID_KEY);
      if (!s) { s = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('r' + Math.random().toString(36).slice(2) + Date.now().toString(36)); sessionStorage.setItem(SID_KEY, s); }
      return s;
    } catch (e) { return ''; }
  }
  function fnv1a(v) { var h = 0x811c9dc5; for (var i = 0; i < v.length; i++) { h ^= v.charCodeAt(i); h = (h * 0x01000193) >>> 0; } return 'f' + h.toString(16); }
  function hashInput(v) {
    if (!v) return Promise.resolve('');
    try {
      if (window.crypto && window.crypto.subtle && window.isSecureContext !== false) {
        var buf = new TextEncoder().encode(v);
        return window.crypto.subtle.digest('SHA-256', buf).then(function (h) {
          return Array.prototype.slice.call(new Uint8Array(h)).map(function (b) { return ('0' + b.toString(16)).slice(-2); }).join('').slice(0, 16);
        }).catch(function () { return fnv1a(v); });
      }
    } catch (e) {}
    return Promise.resolve(fnv1a(v));
  }
  function unknownReason(res) { if (!res) return 'empty'; if (res.down) return 'down'; return 'not_found'; }
  function sendWarnEvent(outcome, reason, res, triggerKind, rawValue, kind) {
    if (!CB_URL || (outcome !== 'warn' && outcome !== 'unknown')) return;
    hashInput(rawValue).then(function (h) {
      var veh = (res && res.vehicle) || {};
      var body = JSON.stringify({
        outcome: outcome, reason: reason || '',
        product_handle: HANDLE, sku: SKU, oe: OE, category: CATEGORY,
        vehicle_descr: veh.descr || '', vehicle_motore: veh.motore || '', vehicle_cbv: veh.cbv || '',
        input_kind: kind || '', input_hash: h, trigger: triggerKind || 'click',
        lang: LANG, device: deviceType(), session_id: warnSessionId()
      });
      try {
        if (navigator.sendBeacon) navigator.sendBeacon(CB_URL + '/api/warn', body);
        else fetch(CB_URL + '/api/warn', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true });
      } catch (e) {}
    });
  }
  var lastOutcome = '';                          // esito ultima verifica (per la richiamata)
  var lastMatch = '';                            // tipo di match dell'ultima verifica: 'oe' | 'anno' | 'uni' | '' (warn/unknown)
                                                 // → scritto nell'ordine come sd_match (classe di match, NON PII): distingue il ✓ OE (garantibile) da anno/universale.
  var cbPhone = '', cbName = '', cbFired = false, cbPoll = null, cbLeft = 60;

  var $ = function (s) { return root.querySelector(s); };
  var chip = $('.svt__chip'), chipName = $('.svt__chip-name');
  var form = $('.svt__form'), input = $('.svt__input'), goBtn = $('.svt__go');
  var after = $('.svt__after'), okBox = $('.svt__ok'), warnBox = $('.svt__warn');
  var vehImg = $('.svt__veh img'), vehName = $('.svt__veh b');
  var VAN = (vehImg && vehImg.getAttribute('src')) || '';   // icona van di default = fallback quando manca l'anno
  var assist = $('.svt__assist'), hsTarget = $('.svt__hsform'), doubts = $('.svt__doubts');

  /* ---------- i18n (SOLO mercati esteri: IT invariato) ----------
   * Estero = telaio/VIN obbligatorio (le targhe estere non le decodifichiamo).
   * I testi del TICKET restano in italiano (operatore IT): qui si traduce SOLO l'UI cliente. */
  var FOREIGN = CFG.isForeign === true;
  var L2 = ((CFG.lang || document.documentElement.lang || 'it') + '').slice(0, 2).toLowerCase();
  var I18N = {
    es: {
      header: 'Comprueba si encaja en tu Daily', tab_telaio: 'Nº de bastidor',
      hint: 'Introduce el número de bastidor (VIN): 17 caracteres, empiezan por <b>ZCF</b>. Lo tienes en el permiso de circulación.',
      go: 'Comprobar compatibilidad', verifying: 'Comprobando…',
      chip_pre: 'Estás viendo los recambios para tu', change_vehicle: 'cambiar vehículo',
      ok_title: '✅ Compatible con tu vehículo',
      okuni_title: '✅ Disponible para tu Daily <small style="font-weight:600;opacity:.85">— compatibilidad confirmada por nuestros especialistas</small>',
      ok_sub: 'Este recambio está entre los <b>disponibles ahora</b> para tu vehículo. 🎉',
      atc: '🛒 Añadir al carrito', ok_cd: '✅ Devolución gratuita si te equivocas de pieza · asistencia dedicada',
      guar: '🛡️ <b>Garantía de montaje 15 días:</b> si no encaja en tu Daily, devolución gratis y te mandamos el correcto — gastos nuestros.',
      warn_title: 'Nos encargamos nosotros ✋',
      warn_msg_veh: 'Para tu vehículo hay <b>varios códigos posibles</b> para este recambio: necesita la verificación de un <b>Especialista Iveco Daily</b> para darte la pieza <b>exacta</b>. Déjanos tus datos aquí abajo: te contactamos enseguida.',
      assist_title: 'Te ayuda un Especialista', assist_p: 'Déjanos tus datos: te contactamos enseguida para darte la pieza exacta para tu Daily.',
      badge_ok: 'Compatible con tu ', badge_okuni: 'Disponible para tu ', badge_warn: 'Este recambio NO consta para tu ', badge_warn_link: 'Verifícalo con nuestros especialistas →',
      m_telaio_short: ['Bastidor incompleto ✋', 'El bastidor (VIN) tiene <b>17 caracteres</b> (empiezan por ZCF): hace falta <b>completo</b>, no solo las últimas cifras. Lo tienes en el permiso de circulación.'],
      m_telaio_not_zcf: ['Revisa el bastidor ✋', 'El bastidor de los Iveco Daily empieza por <b>ZCF</b>: revisa los <b>17 caracteres</b> del permiso de circulación.'],
      m_empty: ['Introduce el bastidor ✋', 'Escribe el número de bastidor (VIN): <b>17 caracteres</b>, empiezan por ZCF, y pulsa Comprobar.'],
      m_not_found: ['Nos encargamos nosotros ✋', 'No hemos podido reconocer el vehículo. Revisa el bastidor, o déjanos tus datos aquí abajo: <b>nos encargamos nosotros</b> de encontrar la pieza exacta.'],
      m_default: ['Revisa e inténtalo de nuevo ✋', 'No hemos podido reconocer el vehículo. Revisa el bastidor, o déjanos tus datos: <b>nos encargamos nosotros</b>.'],
      received_t: '✅ Solicitud recibida', received_m: 'Hemos recibido tu solicitud. Un Especialista Iveco Daily te contactará enseguida por <b>WhatsApp</b> o email.'
    },
    fr: {
      header: 'Vérifie la compatibilité avec ton Daily', tab_telaio: 'N° de châssis',
      hint: 'Saisis le numéro de châssis (VIN) : 17 caractères, commencent par <b>ZCF</b>. Il figure sur la carte grise.',
      go: 'Vérifier la compatibilité', verifying: 'Vérification…',
      chip_pre: 'Tu vois les pièces pour ton', change_vehicle: 'changer de véhicule',
      ok_title: '✅ Compatible avec ton véhicule',
      okuni_title: '✅ Disponible pour ton Daily <small style="font-weight:600;opacity:.85">— compatibilité confirmée par nos spécialistes</small>',
      ok_sub: 'Cette pièce fait partie de celles <b>disponibles maintenant</b> pour ton véhicule. 🎉',
      atc: '🛒 Ajouter au panier', ok_cd: '✅ Retour gratuit en cas d\'erreur de pièce · assistance dédiée',
      guar: '🛡️ <b>Garantie de montage 15 jours :</b> si ça ne monte pas sur ton Daily, retour gratuit et on t\'envoie la bonne — à nos frais.',
      warn_title: 'On s\'en occupe ✋',
      warn_msg_veh: 'Pour ton véhicule, <b>plusieurs codes sont possibles</b> pour cette pièce : la vérification d\'un <b>Spécialiste Iveco Daily</b> est nécessaire pour te donner la pièce <b>exacte</b>. Laisse tes coordonnées ci-dessous : on te recontacte tout de suite.',
      assist_title: 'Un Spécialiste t\'aide', assist_p: 'Laisse tes coordonnées : on te recontacte tout de suite pour te donner la pièce exacte pour ton Daily.',
      badge_ok: 'Compatible avec ton ', badge_okuni: 'Disponible pour ton ', badge_warn: 'Cette pièce ne figure PAS pour ton ', badge_warn_link: 'Vérifie avec nos spécialistes →',
      m_telaio_short: ['Châssis incomplet ✋', 'Le châssis (VIN) comporte <b>17 caractères</b> (commencent par ZCF) : il le faut <b>complet</b>, pas seulement les derniers chiffres. Il figure sur la carte grise.'],
      m_telaio_not_zcf: ['Vérifie le châssis ✋', 'Le châssis des Iveco Daily commence par <b>ZCF</b> : revérifie les <b>17 caractères</b> sur la carte grise.'],
      m_empty: ['Saisis le châssis ✋', 'Écris le numéro de châssis (VIN) : <b>17 caractères</b>, commencent par ZCF, puis appuie sur Vérifier.'],
      m_not_found: ['On s\'en occupe ✋', 'Nous n\'avons pas pu reconnaître le véhicule. Vérifie le châssis, ou laisse tes coordonnées ci-dessous : <b>on s\'en occupe</b> pour trouver la bonne pièce.'],
      m_default: ['Vérifie et réessaie ✋', 'Nous n\'avons pas pu reconnaître le véhicule. Vérifie le châssis, ou laisse tes coordonnées : <b>on s\'en occupe</b>.'],
      received_t: '✅ Demande reçue', received_m: 'Nous avons bien reçu ta demande. Un Spécialiste Iveco Daily te recontacte très vite par <b>WhatsApp</b> ou par e-mail.'
    },
    de: {
      header: 'Prüfe die Passform für deinen Daily', tab_telaio: 'Fahrgestellnr.',
      hint: 'Gib die Fahrgestellnummer (FIN) ein: 17 Zeichen, beginnen mit <b>ZCF</b>. Du findest sie im Fahrzeugschein.',
      go: 'Kompatibilität prüfen', verifying: 'Prüfe…',
      chip_pre: 'Du siehst die Ersatzteile für deinen', change_vehicle: 'Fahrzeug ändern',
      ok_title: '✅ Kompatibel mit deinem Fahrzeug',
      okuni_title: '✅ Verfügbar für deinen Daily <small style="font-weight:600;opacity:.85">— Kompatibilität von unseren Spezialisten bestätigt</small>',
      ok_sub: 'Dieses Ersatzteil gehört zu den <b>jetzt verfügbaren</b> für dein Fahrzeug. 🎉',
      atc: '🛒 In den Warenkorb', ok_cd: '✅ Kostenlose Rückgabe bei falschem Teil · persönlicher Support',
      guar: '🛡️ <b>15 Tage Montagegarantie:</b> Passt es nicht an deinen Daily, kostenlose Rückgabe und wir schicken das richtige — auf unsere Kosten.',
      warn_title: 'Wir kümmern uns darum ✋',
      warn_msg_veh: 'Für dein Fahrzeug gibt es <b>mehrere mögliche Codes</b> für dieses Ersatzteil: Ein <b>Iveco-Daily-Spezialist</b> muss das <b>exakte</b> Teil prüfen. Hinterlasse unten deine Daten: Wir melden uns sofort.',
      assist_title: 'Ein Spezialist hilft dir', assist_p: 'Hinterlasse deine Daten: Wir melden uns sofort, um dir das exakte Teil für deinen Daily zu geben.',
      badge_ok: 'Kompatibel mit deinem ', badge_okuni: 'Verfügbar für deinen ', badge_warn: 'Dieses Ersatzteil ist nicht gelistet für deinen ', badge_warn_link: 'Mit unseren Spezialisten prüfen →',
      m_telaio_short: ['Fahrgestellnr. unvollständig ✋', 'Die Fahrgestellnummer (FIN) hat <b>17 Zeichen</b> (beginnen mit ZCF): <b>vollständig</b> nötig, nicht nur die letzten Ziffern. Du findest sie im Fahrzeugschein.'],
      m_telaio_not_zcf: ['Fahrgestellnr. prüfen ✋', 'Die Fahrgestellnummer der Iveco Daily beginnt mit <b>ZCF</b>: Prüfe die <b>17 Zeichen</b> im Fahrzeugschein.'],
      m_empty: ['Fahrgestellnr. eingeben ✋', 'Gib die Fahrgestellnummer (FIN) ein: <b>17 Zeichen</b>, beginnen mit ZCF, und klicke auf Prüfen.'],
      m_not_found: ['Wir kümmern uns darum ✋', 'Wir konnten das Fahrzeug nicht erkennen. Prüfe die Fahrgestellnummer oder hinterlasse unten deine Daten: <b>wir kümmern uns darum</b>, das exakte Teil zu finden.'],
      m_default: ['Prüfen und erneut versuchen ✋', 'Wir konnten das Fahrzeug nicht erkennen. Prüfe die Fahrgestellnummer oder hinterlasse deine Daten: <b>wir kümmern uns darum</b>.'],
      received_t: '✅ Anfrage erhalten', received_m: 'Wir haben deine Anfrage erhalten. Ein Iveco-Daily-Spezialist meldet sich in Kürze per <b>WhatsApp</b> oder E-Mail.'
    },
    en: {
      header: 'Check if it fits your Daily', tab_telaio: 'Chassis no. (VIN)',
      hint: 'Enter the chassis number (VIN): 17 characters, starting with <b>ZCF</b>. You\'ll find it on your vehicle registration document.',
      go: 'Check compatibility', verifying: 'Checking…',
      chip_pre: 'You\'re viewing the parts for your', change_vehicle: 'change vehicle',
      ok_title: '✅ Compatible with your vehicle',
      okuni_title: '✅ Available for your Daily <small style="font-weight:600;opacity:.85">— compatibility confirmed by our specialists</small>',
      ok_sub: 'This part is among those <b>available now</b> for your vehicle. 🎉',
      atc: '🛒 Add to cart', ok_cd: '✅ Free return if you pick the wrong part · dedicated support',
      guar: '🛡️ <b>15-day fitment guarantee:</b> if it doesn\'t fit your Daily, free return and we\'ll send the right one — on us.',
      warn_title: 'We\'ll take care of it ✋',
      warn_msg_veh: 'For your vehicle there are <b>several possible codes</b> for this part: an <b>Iveco Daily Specialist</b> needs to check to give you the <b>exact</b> part. Leave your details below: we\'ll contact you right away.',
      assist_title: 'A Specialist will help you', assist_p: 'Leave your details: we\'ll contact you right away to give you the exact part for your Daily.',
      badge_ok: 'Compatible with your ', badge_okuni: 'Available for your ', badge_warn: 'This part is NOT listed for your ', badge_warn_link: 'Check with our specialists →',
      m_telaio_short: ['Chassis number incomplete ✋', 'The chassis number (VIN) has <b>17 characters</b> (starting with ZCF): it must be <b>complete</b>, not just the last digits. You\'ll find it on your registration document.'],
      m_telaio_not_zcf: ['Check the chassis number ✋', 'Iveco Daily chassis numbers start with <b>ZCF</b>: double-check the <b>17 characters</b> on your registration document.'],
      m_empty: ['Enter the chassis number ✋', 'Type the chassis number (VIN): <b>17 characters</b>, starting with ZCF, then press Check.'],
      m_not_found: ['We\'ll take care of it ✋', 'We couldn\'t recognise the vehicle. Check the chassis number, or leave your details below: <b>we\'ll take care of it</b> and find the exact part.'],
      m_default: ['Check and try again ✋', 'We couldn\'t recognise the vehicle. Check the chassis number, or leave your details: <b>we\'ll take care of it</b>.'],
      received_t: '✅ Request received', received_m: 'We\'ve received your request. An Iveco Daily Specialist will contact you shortly on <b>WhatsApp</b> or by email.'
    }
  };
  var DICT = (FOREIGN && I18N[L2]) ? I18N[L2] : null;
  function TT(it, key) { return (DICT && DICT[key] != null) ? DICT[key] : it; }
  function applyForeignI18n() {
    if (!DICT) return;
    // Estero = SOLO telaio/VIN: nascondo il tab Targa, forzo il tab Telaio.
    var tTarga = root.querySelector('.svt__tab[data-kind="targa"]');
    var tTelaio = root.querySelector('.svt__tab[data-kind="telaio"]');
    if (tTarga) { tTarga.style.display = 'none'; tTarga.classList.remove('is-on'); }
    if (tTelaio) { tTelaio.classList.add('is-on'); tTelaio.textContent = DICT.tab_telaio; }
    if (input) { input.maxLength = 17; input.placeholder = 'ZCFC1350…'; input.setAttribute('aria-label', DICT.tab_telaio); }
    var eu = root.querySelector('.svt__eu'); if (eu) eu.style.display = 'none';
    var h = root.querySelector('.svt__h'); if (h) h.innerHTML = '<span>🔎</span> ' + DICT.header;
    var hint = root.querySelector('.svt__hint'); if (hint) hint.innerHTML = DICT.hint;
    if (goBtn) goBtn.textContent = DICT.go;
    var subEl = root.querySelector('.svt__ok-sub'); if (subEl) subEl.innerHTML = DICT.ok_sub;
    var cdEl = okBox && okBox.querySelector('.svt__cd'); if (cdEl) cdEl.textContent = DICT.ok_cd;
    var atcEl = okBox && okBox.querySelector('.svt__atc');
    if (atcEl) { var pr = (atcEl.textContent.split('·')[1] || '').trim(); atcEl.textContent = DICT.atc + (pr ? ' · ' + pr : ''); }
    var at = root.querySelector('.svt__assist-t'); if (at) at.textContent = DICT.assist_title;
    var ap = root.querySelector('.svt__assist-p'); if (ap) ap.textContent = DICT.assist_p;
    // Chip "stai vedendo i ricambi…" (ricreo e ri-aggancio i riferimenti).
    if (chip) {
      chip.innerHTML = '🚗 ' + DICT.chip_pre + ' <b class="svt__chip-name">Iveco Daily</b> · <a class="svt__reset" role="button">' + DICT.change_vehicle + '</a>';
      chipName = root.querySelector('.svt__chip-name');
    }
  }

  /* ---------- util ---------- */
  function normPlate(v) { return (v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function isPlate(v) { return /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/.test(v); }
  // Targhe VECCHIE (ora nell'indice, refresh 20/10): numeriche (BZ558386) o serie (MI8K4991).
  // Stessi pattern del worker (precompute_indexes TARGA_OLD_*) → le inoltriamo invece di bloccarle.
  function isOldPlate(v) { return /^[A-Z]{2}[0-9]{4,}$/.test(v) || /^[A-Z]{2}[0-9A-Z]{2}[0-9]{4}$/.test(v); }
  function isVin(v) { return /^[A-HJ-NPR-Z0-9]{17}$/.test(v) && v.indexOf('ZCF') === 0; }
  // Categoria dell'errore di input (per messaggi mirati + per imparare dal dato in GA4). NO valore grezzo (PII).
  function badReason(np, mode) {
    if (mode === 'telaio') {
      if (!np) return 'empty';
      if (np.length < 17) return 'telaio_short';           // mettono le ultime cifre / telaio parziale
      if (np.indexOf('ZCF') !== 0) return 'telaio_not_zcf'; // non è un Daily / errore
      return 'bad_telaio';
    }
    if (!np) return 'empty';
    if (/^[A-Z]{2}[0-9]{4,}[A-Z]?$/.test(np)) return 'old_plate';  // provincia+numeri = targa vecchia (non in archivio)
    return 'bad_plate';
  }
  // Campo TELAIO inline, REATTIVO: quando la targa non risolve, compare SUBITO qui sotto
  // (niente click sul tab, niente campo svuotato — richiesta CEO 20/10). Creato una volta.
  function telaioFallback() {
    var warnMsg = root.querySelector('.svt__warn-msg');
    if (!warnMsg) return null;
    var box = root.querySelector('.svt__telaio-fb');
    if (box) return box;
    box = document.createElement('div');
    box.className = 'svt__telaio-fb';
    box.style.cssText = 'margin-top:10px;display:flex;gap:8px;flex-wrap:wrap;align-items:center';
    box.innerHTML = '<input type="text" class="svt__tfb-in" maxlength="17" placeholder="ZCFC1350…" autocomplete="off" aria-label="Telaio" style="flex:1;min-width:150px;padding:11px 12px;border:1px solid #cbd5e1;border-radius:8px;font-size:15px;text-transform:uppercase">'
      + '<button type="button" class="svt__tfb-go" style="padding:11px 16px;border:0;border-radius:8px;background:#111827;color:#fff;font-weight:700;cursor:pointer;white-space:nowrap">Verifica col telaio</button>';
    warnMsg.insertAdjacentElement('afterend', box);
    var tin = box.querySelector('.svt__tfb-in'), tgo = box.querySelector('.svt__tfb-go');
    function goTelaio() {
      var nv = normPlate(tin.value);
      if (!isVin(nv)) { tin.style.borderColor = '#ef4444'; try { tin.focus(); } catch (e) {} track('badformat', { mode: 'telaio', reason: badReason(nv, 'telaio') }); return; }
      tin.style.borderColor = '#cbd5e1'; run(nv, 'telaio');
    }
    tgo.addEventListener('click', goTelaio);
    tin.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); goTelaio(); } });
    return box;
  }
  // Contesto veicolo su OGNI evento del widget → in GA4 confronto "chi ha loggato il veicolo vs no" (misura del LIFT).
  var GEN_BANDS = [[1978,1989,'1978-1989'],[1990,1995,'1990-1995'],[1996,1999,'1996-1999'],[2000,2005,'2000-2005'],[2006,2008,'2006-2008'],[2009,2011,'2009-2011'],[2012,2013,'2012-2013'],[2014,2015,'2014-2015'],[2016,2018,'2016-2018'],[2019,2021,'2019-2021'],[2022,2023,'2022-2023'],[2024,2100,'2024+']];
  function vehGen(descr) { var y = yearFromDescr(descr); if (!y) return ''; for (var i = 0; i < GEN_BANDS.length; i++) { if (y >= GEN_BANDS[i][0] && y <= GEN_BANDS[i][1]) return GEN_BANDS[i][2]; } return ''; }
  function vehInfo() { var v; try { v = JSON.parse(localStorage.getItem(KEY)); } catch (e) {} return (v && v.descr) ? { vehicle_set: 'yes', vehicle_gen: vehGen(v.descr) } : { vehicle_set: 'no', vehicle_gen: '' }; }
  function gaClientId() { var m = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.([\d.]+)/); return m ? m[1] : ''; }  // client_id GA4 dal cookie _ga
  function track(name, data) {
    window.dataLayer = window.dataLayer || [];
    var ev = 'sd_verify_' + name;
    var payload = Object.assign({ event: ev, product_handle: HANDLE }, vehInfo(), data || {});
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') {
      window.gtag('event', ev, payload);                                          // rimane: Google Ads (AW) lo cattura (audience/gclid)
      window.gtag('event', ev, Object.assign({ send_to: GA4_ID }, payload));      // GA4 esplicito (send_to) — verificato dal vivo
    }
    // Beacon di NOSTRA proprietà al worker callback-sd per gli stadi alti del funnel:
    // 'click' (CTA verifica) e 'result' (esito). Rende il funnel esatto e indipendente
    // dal trigger GTM click_verifica_targa (che col nuovo widget non aggancia più).
    if ((name === 'click' || name === 'result') && CB_URL) {
      try {
        var evBody = JSON.stringify({ stage: name, handle: HANDLE, outcome: (data && data.outcome) || '' });
        if (navigator.sendBeacon) navigator.sendBeacon(CB_URL + '/api/ev', evBody);
        else fetch(CB_URL + '/api/ev', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: evBody, keepalive: true });
      } catch (e) {}
    }
  }
  function yearFromDescr(d) {
    var m = (d || '').match(/(19|20)\d{2}/); if (m) return parseInt(m[0], 10);
    var p = (d || '').match(/\((\d{2})\)/); if (p) { var y = parseInt(p[1], 10); return y < 40 ? 2000 + y : 1900 + y; }
    return null;
  }
  function modelImg(descr) {
    var y = yearFromDescr(descr), map = CFG.modelImages || {};
    // map opzionale generazione->url; per ora fallback su icona inline
    if (y) { for (var k in map) { var r = k.split('-'); if (y >= +r[0] && y <= (+r[1] || 9999)) return map[k]; } }
    return '';
  }

  /* ---------- worker ---------- */
  function ask(value, kind) {
    var url = kind === 'telaio'
      ? WORKER + '/api/telaio?vin=' + encodeURIComponent(value)
      : WORKER + '/api/targa?targa=' + encodeURIComponent(value);
    var ctrl = new AbortController(); var to = setTimeout(function () { ctrl.abort(); }, 6000);
    return fetch(url, { signal: ctrl.signal })
      .then(function (r) { clearTimeout(to); return r.json().then(function (j) { j._status = r.status; return j; }); })
      .catch(function () { return { _status: 0, down: true }; });
  }
  // esito: 'ok' (compatibile per OE o ANNO) | 'okuni' (universale: disponibile, confermiamo noi)
  //        | 'warn' (risolto ma non per questo mezzo) | 'unknown' (targa non risolta / down)
  function outcomeOf(res) {
    lastMatch = '';
    if (!res || res.down || res.need_manual || res.error || res._status >= 400) return 'unknown';
    var list = res.products || [];
    for (var i = 0; i < list.length; i++) {
      if ((PID && String(list[i].id) === PID) || (list[i].handle || '').toLowerCase() === HANDLE) { lastMatch = 'oe'; return 'ok'; }   // match per id (stabile IT/estero) o handle → OE (dato IVECO), GARANTIBILE
    }
    // Non in lista per OE. Match per ANNO: il prodotto dichiara le generazioni (modello_daily) e
    // la generazione del veicolo è tra quelle → è il pezzo di quell'anno (dato autoritativo dal titolo).
    var veh = res.vehicle;
    if (veh && veh.descr) {
      var gen = vehGen(veh.descr);
      if (gen && Object.prototype.toString.call(CFG.modello_daily) === '[object Array]' && CFG.modello_daily.indexOf(gen) !== -1) { lastMatch = 'anno'; return 'ok'; }
      // Universale: ricambio Daily senza fitment modello-specifico (assenza di dato ≠ incompatibile).
      if (CFG.universale === true) { lastMatch = 'uni'; return 'okuni'; }
    }
    return 'warn';
  }

  /* ---------- render ---------- */
  function hideNativeAtc(on) {
    // nasconde SOLO l'add-to-cart principale, non i quick-buy dei prodotti correlati.
    // setProperty(...,'important') perché il tema forza display:flex !important.
    document.querySelectorAll('.product-form__add-button, [name="add"]').forEach(function (b) {
      if (b.closest('.svt')) return;
      if (b.closest('[class*="complementary"],[class*="recommend"],[class*="related"],[class*="quick"],.product-card')) return;
      if (on) b.style.setProperty('display', 'none', 'important');
      else b.style.removeProperty('display');
    });
  }
  function escH(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  // Badge verdetto VISIBILE vicino all'acquisto (richiesta CEO): molti non vedono il form in fondo.
  // Usa il veicolo già salvato (anche dalla targa messa in home → localStorage condiviso 'sd_vehicle').
  function verdictBadge(outcome, res) {
    var sv; try { sv = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
    var badge = document.querySelector('.svt-badge');
    if (!sv || !sv.value || outcome === 'unknown') { if (badge) badge.style.display = 'none'; return; }
    if (!badge) {
      // Posto PIÙ visibile: SOPRA il titolo che il cliente VEDE. Il tema (product-prova.js)
      // ricostruisce la pagina e crea un titolo nuovo .pp-title dentro #pp-head (sopra la galleria):
      // è QUELLO il titolo visibile — il .product-meta__title originale viene spostato/nascosto.
      var anchor = document.querySelector('.pp-title')
        || document.querySelector('.product-meta__title, .product__title, .product-title, .product-single__title');
      if (!anchor) { var h1s = document.querySelectorAll('h1'); anchor = h1s[h1s.length - 1] || null; }
      if (!anchor) anchor = document.querySelector('.product-form__add-button, [name="add"]');
      if (!anchor || !anchor.parentNode) return;
      badge = document.createElement('div'); badge.className = 'svt-badge';
      anchor.parentNode.insertBefore(badge, anchor);
      badge.style.cssText = 'margin:0 0 12px;padding:12px 14px;border-radius:10px;font-size:15px;line-height:1.35;cursor:pointer;border-left:5px solid';
      badge.addEventListener('click', function () { try { (document.querySelector('.svt') || badge).scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} });
    }
    var veh = (res && res.vehicle) || {};
    var label = 'Iveco Daily ' + (veh.descr || sv.descr || '');
    var who = ' · ' + (sv.kind === 'telaio' ? 'telaio ' : 'targa ') + escH(sv.value);
    badge.style.display = 'block';
    if (outcome === 'ok' || outcome === 'okuni') {
      badge.style.background = '#e9f7ec'; badge.style.borderLeftColor = '#2e7d32'; badge.style.color = '#14532d';
      badge.innerHTML = '✅ <b>' + (outcome === 'okuni' ? TT('Disponibile per il tuo ', 'badge_okuni') : TT('Compatibile con il tuo ', 'badge_ok')) + escH(label) + '</b><span style="opacity:.8">' + who + '</span>';
    } else { // warn
      badge.style.background = '#fff3e0'; badge.style.borderLeftColor = '#ef6c00'; badge.style.color = '#8a3b00';
      badge.innerHTML = '⚠️ <b>' + TT('Questo ricambio NON risulta per il tuo ', 'badge_warn') + escH(label) + '</b><span style="opacity:.85">' + who + '</span><br><span style="text-decoration:underline">' + TT('Verifica con i nostri specialisti →', 'badge_warn_link') + '</span>';
    }
  }
  function render(outcome, res, reason) {
    after.classList.add('is-on');
    verdictBadge(outcome, res);
    var compat = outcome === 'ok' || outcome === 'okuni';
    okBox.style.display = compat ? 'block' : 'none';
    warnBox.style.display = compat ? 'none' : 'block';
    var okt = compat && okBox.querySelector('.svt__t');
    if (okt) okt.innerHTML = (outcome === 'okuni')
      ? TT('✅ Disponibile per il tuo Daily <small style="font-weight:600;opacity:.85">— compatibilità confermata dai nostri specialisti</small>', 'okuni_title')
      : TT('✅ Compatibile con il tuo veicolo', 'ok_title');
    // GATE "Reso gratuito": è un claim che NON deve comparire sull'universale (match soft "confermiamo noi").
    // Sul ✓ forte (OE/anno) resta com'era; sull'universale si nasconde.
    var cd = okBox.querySelector('.svt__cd');
    if (cd) cd.style.display = (outcome === 'okuni') ? 'none' : '';
    // BADGE GARANZIA MONTAGGIO (15 giorni) — SOLO sul ✓ OE-match (dato IVECO autoritativo, lastMatch='oe').
    // MAI su anno-match né su universale (okuni): lì non c'è il dato OE che la garanzia paga (regola CEO).
    var guar = okBox.querySelector('.svt__guar');
    if (guar) {
      if (outcome === 'ok' && lastMatch === 'oe') {
        guar.innerHTML = TT('🛡️ <b>Garanzia montaggio 15 giorni:</b> se non monta sul tuo Daily, reso gratis e ti mandiamo quello giusto — spese nostre.', 'guar');
        guar.style.display = '';
      } else {
        guar.innerHTML = ''; guar.style.display = 'none';
      }
    }
    assist.classList.toggle('is-on', !compat);          // form protagonista sul non-compatibile
    hideNativeAtc(compat);                               // sul compatibile l'ATC "scende" nel riquadro
    // VEICOLO + foto: mostrati SEMPRE che il veicolo è stato riconosciuto (compatibile O da verificare).
    var veh = res && res.vehicle;
    var vehBox = $('.svt__veh');
    if (veh && veh.descr) {
      vehName.textContent = 'Iveco Daily ' + veh.descr + (veh.motore ? ' · ' + veh.motore : '');
      vehImg.src = modelImg(veh.descr) || VAN;
      if (vehBox) vehBox.style.display = 'flex';
    } else if (vehBox) {
      vehBox.style.display = 'none';
    }
    // Messaggio "da verificare": diverso se il veicolo è stato riconosciuto o no.
    var warnT = $('.svt__warn-t'), warnMsg = $('.svt__warn-msg');
    var _fb = root.querySelector('.svt__telaio-fb'); if (_fb) _fb.style.display = 'none';  // default: nascosto
    if (!compat && warnMsg) {
      if (veh && veh.descr) {
        if (warnT) warnT.innerHTML = TT('Ci pensiamo noi ✋', 'warn_title');
        warnMsg.innerHTML = TT('Per il tuo veicolo risultano <b>più codici possibili</b> per questo ricambio: serve la verifica di un nostro <b>Specialista Iveco Daily</b> per darti il pezzo <b>esatto</b>. Lascia i tuoi dati qui sotto: ti contattiamo subito.', 'warn_msg_veh');
      } else {
        // Messaggio MIRATO in base all'errore → gli diciamo cosa fare, per ridurre gli errori.
        var MSGS = {
          old_plate:      ['Targa non in archivio ✋', 'Sembra una <b>targa vecchia</b> (lettere di provincia): quelle non sono nell\'archivio. Usa il <b>telaio</b> — 17 caratteri dal libretto, iniziano con <b>ZCF</b> — col pulsante <b>Telaio</b> qui sopra.'],
          telaio_short:   TT(['Telaio incompleto ✋', 'Il <b>telaio</b> ha <b>17 caratteri</b> (iniziano con ZCF): serve <b>completo</b>, non le ultime cifre. Lo trovi sul <b>libretto</b> (quadro E) o inciso sul mezzo.'], 'm_telaio_short'),
          telaio_not_zcf: TT(['Controlla il telaio ✋', 'Il telaio degli Iveco Daily inizia con <b>ZCF</b>: ricontrolla i <b>17 caratteri</b> sul libretto.'], 'm_telaio_not_zcf'),
          bad_plate:      ['Controlla la targa ✋', 'Controlla la <b>targa</b>: formato <b>AB 123 CD</b>. Se è vecchia o non la ricordi, usa il <b>telaio</b> col pulsante sopra.'],
          empty:          TT(['Inserisci targa o telaio ✋', 'Scrivi la <b>targa</b> (AB 123 CD) oppure il <b>telaio</b> (17 caratteri, iniziano con ZCF) e premi Verifica.'], 'm_empty'),
          not_found:      TT(['Ci pensiamo noi ✋', 'Questa targa non risulta (o è troppo recente). Prova col <b>telaio</b>, oppure lascia i tuoi dati qui sotto: <b>ci pensiamo noi</b> a trovarti il pezzo esatto.'], 'm_not_found')
        };
        var m = MSGS[reason] || TT(['Controlla e riprova ✋', 'Non siamo riusciti a riconoscere il veicolo. Controlla targa/telaio, oppure lascia i tuoi dati: <b>ci pensiamo noi</b>.'], 'm_default');
        if (warnT) warnT.innerHTML = m[0];
        warnMsg.innerHTML = m[1];
        // Telaio REATTIVO: compare subito il campo telaio, già pronto (niente tab, niente retype).
        // Estero: l'input principale è GIÀ il telaio → niente campo duplicato.
        if (!FOREIGN) {
          var fb = telaioFallback();
          if (fb) { fb.style.display = 'flex'; setTimeout(function () { try { fb.querySelector('.svt__tfb-in').focus({ preventScroll: true }); } catch (e) {} }, 50); }
        }
      }
    }
    if (!compat) { loadHsForm(); prefillHsTarga(); }
  }
  function showChip(descr) {
    chipName.textContent = 'Iveco Daily ' + (descr || '');
    chip.classList.add('is-on'); form.style.display = 'none';
  }
  function resetVehicle() {
    localStorage.removeItem(KEY);
    chip.classList.remove('is-on'); form.style.display = '';
    after.classList.remove('is-on'); assist.classList.remove('is-on'); hideNativeAtc(false);
    if (input) input.value = '';
    var _fb = root.querySelector('.svt__telaio-fb'); if (_fb) _fb.style.display = 'none';
    var _bd = document.querySelector('.svt-badge'); if (_bd) _bd.style.display = 'none';
    clearVerifyAttrs();   // azzera gli attributi verifica sul carrello → niente targa/veicolo stantio nell'ordine
    track('reset', {});
  }

  /* ---------- hubspot ---------- */
  // Il form HubSpot v2 rende in un IFRAME same-origin: la targa va prefillata
  // DENTRO l'iframe, SOLO sul campo name="targa" (mai su phone).
  function cookieVal(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function fillField(doc, name, val) {
    if (!val) return;
    var el = doc.querySelector('[name="' + name + '"]');
    if (el && !el.value) {
      el.value = val;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  // Aggiunge un pezzo di testo a un campo TICKET (subject/content) UNA SOLA VOLTA (il prefill si ripete).
  function appendTicket(doc, name, add) {
    if (!add) return;
    var el = doc.querySelector('[name="' + name + '"]');
    if (!el || el.dataset.sdCtx) return;
    el.dataset.sdCtx = '1';
    var base = (el.value || '').trim();
    el.value = base ? (base + ' — ' + add) : add;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function prefillHsTarga(tries) {
    tries = tries || 0;
    var done = false;
    try {
      var ifr = root.querySelector('.svt__hsform iframe');
      var doc = ifr && (ifr.contentDocument || (ifr.contentWindow || {}).document);
      if (doc) {
        // CTA del bottone HubSpot allineata al nuovo flusso (richiamata) — override lato client, mirato
        var sb = doc.querySelector('input.hs-button[type="submit"], .hs-button[type="submit"], button.hs-button[type="submit"], .hs-button');
        if (sb) { var _cta = (CFG.callbackCta || 'Ottieni supporto immediato'); if (sb.tagName === 'INPUT') sb.value = _cta; else sb.textContent = _cta; }
        // Estero: il form HubSpot ha il campo "telaio" (VIN), non "targa".
        var _fn = FOREIGN ? 'telaio' : 'targa';
        var ta = doc.querySelector('textarea[name="' + _fn + '"], input[name="' + _fn + '"]');
        // SEMPRE ciò che il cliente ha scritto ORA nel box (non un valore vecchio memorizzato)
        var v = (input && input.value && input.value.trim()) || lastValue || (readSaved() || {}).value || '';
        if (ta && v) {
          ta.value = v;
          ta.dispatchEvent(new Event('input', { bubbles: true }));
          ta.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Attribuzione: il tema riempie il gclid ma NON il timestamp → lo iniettiamo noi dai cookie.
        fillField(doc, 'gclid', cookieVal('_gclid'));
        fillField(doc, 'gclid_timestamp', cookieVal('_gclid_ts'));
        fillField(doc, 'fbclid', cookieVal('_fbclid'));
        fillField(doc, 'fbclid_timestamp', cookieVal('_fbclid_ts'));
        // Contesto verifica nel TICKET → l'operatore capisce SUBITO il cliente (che mezzo, che esito)
        // e sappiamo PERCHÉ nasce il ticket (spesso da 'warn' = veicolo noto ma pezzo da confermare).
        try {
          var _out = { ok: 'COMPATIBILE', warn: 'DA VERIFICARE', unknown: 'NON RICONOSCIUTO' }[lastOutcome] || (lastOutcome || '');
          var _sv = readSaved() || {};
          var _veic = _sv.descr ? ('Iveco Daily ' + _sv.descr + (_sv.motore ? ' · ' + _sv.motore : '')) : '';
          var _prod = ((((document.querySelector('h1, .product-title, [class*="product-title"]') || {}).textContent) || HANDLE) + '').trim().replace(/\s+/g, ' ').slice(0, 90);
          var _ctx = 'Esito verifica: ' + _out + (_veic ? ' | Veicolo: ' + _veic : '') + (v ? (FOREIGN ? ' | Telaio: ' : ' | Targa/Telaio: ') + v : '') + ' | Prodotto: ' + _prod + ' (' + HANDLE + ')';
          appendTicket(doc, 'TICKET.content', _ctx);
          appendTicket(doc, 'TICKET.subject', 'Verifica ' + _out + (_sv.descr ? ' · ' + _sv.descr : ''));
        } catch (e) {}
        done = !!(ta && v);
      }
    } catch (e) {}
    if (!done && tries < 10) setTimeout(function () { prefillHsTarga(tries + 1); }, 300);
  }
  function loadHsForm() {
    if (root.dataset.hs || !CFG.hsForm) return;
    function create() {
      window.hbspt.forms.create({
        portalId: CFG.hsPortal || '48391583', formId: CFG.hsForm, region: CFG.hsRegion || 'na1',
        target: '.svt__hsform',
        onFormReady: function () { prefillHsTarga(); },
        // cattura il numero PRIMA che HubSpot sostituisca il form col ringraziamento
        onFormSubmit: function () { cbPhone = readHsField('phone'); cbName = readHsField('firstname'); },
        // submit riuscito (ticket creato) → lancia la richiamata immediata + countdown
        // Estero: niente richiamata telefonica automatica, MA si chiama comunque il worker:
        // per i lead esteri il worker NON telefona e fa partire il WhatsApp di presa in carico
        // (spokiEstero). Prima si saltava del tutto fireCallback() -> l'estero non riceveva nulla.
        onFormSubmitted: function () { fireCallback(); }
      });
      root.dataset.hs = '1';
    }
    if (window.hbspt && window.hbspt.forms) return create();
    var s = document.createElement('script'); s.src = '//js.hsforms.net/forms/embed/v2.js';
    s.onload = create; document.head.appendChild(s);
  }

  /* ---------- richiamata immediata (countdown cliente) ---------- */
  function readHsField(name) {
    try {
      var ifr = root.querySelector('.svt__hsform iframe');
      var doc = ifr && (ifr.contentDocument || (ifr.contentWindow || {}).document);
      var el = doc && doc.querySelector('[name="' + name + '"]');
      return el ? (el.value || '').trim() : '';
    } catch (e) { return ''; }
  }
  function cbBox() { return root.querySelector('.svt__cb'); }
  function fireCallback() {
    if (cbFired) return; cbFired = true;
    var sv = readSaved() || {};
    var payload = {
      name: cbName, phone: cbPhone,
      targa: (input && input.value && input.value.trim()) || lastValue || sv.value || '',
      product_handle: HANDLE, product_title: (CFG.productTitle || ''),
      outcome: lastOutcome, gclid: cookieVal('_gclid'), ga_client_id: gaClientId()
    };
    track('callback_request', { outcome: lastOutcome });
    fetch(CB_URL + '/api/request', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (res) { showCountdown(res); })
      .catch(function () { showCountdown({ state: 'live' }); });
  }
  function showCountdown(res) {
    var box = cbBox(); if (!box) return;
    var hs = root.querySelector('.svt__hsform'); if (hs) hs.style.display = 'none';
    var at = root.querySelector('.svt__assist-t'), ap = root.querySelector('.svt__assist-p');
    if (at) at.style.display = 'none'; if (ap) ap.style.display = 'none';
    assist.classList.add('is-on');
    box.style.display = 'block';
    // Estero: nessuna telefonata (ci pensa il WhatsApp del worker). Niente countdown: messaggio
    // "richiesta ricevuta" nella lingua della pagina.
    if (FOREIGN) {
      box.className = 'svt__cb svt__cb--closed';
      var _rt = (DICT && DICT.received_t) || '✅ Request received';
      var _rm = (DICT && DICT.received_m) || 'We\'ve received your request. An Iveco Daily Specialist will contact you shortly on WhatsApp or by email.';
      box.innerHTML = '<div class="svt__cb-t">' + _rt + '</div><div class="svt__cb-m">' + _rm + '</div>';
      return;
    }
    if (res && res.state === 'closed') {
      box.className = 'svt__cb svt__cb--closed';
      box.innerHTML = '<div class="svt__cb-t">✅ Richiesta ricevuta</div><div class="svt__cb-m">' +
        String(res.message || 'Ti ricontattiamo nelle nostre fasce orarie.').replace(/\n/g, '<br>') + '</div>';
      return;
    }
    cbLeft = 60; box.className = 'svt__cb svt__cb--live';
    var leadId = res && res.lead_id;
    paintCountdown();
    if (cbPoll) clearInterval(cbPoll);
    cbPoll = setInterval(function () {
      cbLeft--;
      if (leadId) {
        fetch(CB_URL + '/api/status?lead=' + encodeURIComponent(leadId))
          .then(function (r) { return r.json(); })
          .then(function (s) { if (s.status === 'calling') { clearInterval(cbPoll); paintCalling(s.agent); } })
          .catch(function () {});
      }
      if (cbLeft <= 0) { clearInterval(cbPoll); paintQueue(); return; }
      paintCountdown();
    }, 1000);
  }
  function paintCountdown() {
    var box = cbBox(); if (!box) return;
    box.innerHTML = '<div class="svt__cb-ring"><span>' + Math.max(0, cbLeft) + '</span></div>' +
      '<div class="svt__cb-t">📞 Ti richiamiamo ORA</div>' +
      '<div class="svt__cb-m">Tieni il telefono a portata: un nostro Specialista Iveco Daily ti chiama tra pochi secondi.</div>';
  }
  function paintCalling(agent) {
    var box = cbBox(); if (!box) return;
    box.className = 'svt__cb svt__cb--calling';
    box.innerHTML = '<div class="svt__cb-t">📞 Ti stiamo chiamando ORA</div>' +
      '<div class="svt__cb-m">Rispondi: è il tuo Specialista Iveco Daily' + (agent ? ' (' + agent + ')' : '') + '. 📱</div>';
    track('callback_calling', {});
  }
  function paintQueue() {
    var box = cbBox(); if (!box) return;
    box.className = 'svt__cb svt__cb--queue';
    box.innerHTML = '<div class="svt__cb-t">Ci siamo quasi ✋</div>' +
      '<div class="svt__cb-m">Più richieste del previsto in questo momento: <b>ti richiamiamo noi a brevissimo</b>. Tieni il telefono a portata.</div>';
    track('callback_queue', {});
  }

  /* ---------- add to cart (bottone contestuale = stesso add-to-cart) ---------- */
  function addToCart() {
    var qtyEl = document.querySelector('.product-form [name="quantity"], [name="quantity"]');
    var qty = qtyEl && +qtyEl.value > 0 ? +qtyEl.value : 1;
    var id = CFG.variantId;
    track('add_to_cart', { variant_id: id });
    // Rinfresca gli attributi verifica sul carrello PRIMA del redirect al checkout,
    // così finiscono in order.note_attributes. Il box verde (ATC) appare solo
    // sull'esito compatibile → sd_outcome='ok'. Veicolo dal localStorage salvato.
    var sv = readSaved() || {};
    var upd = verifyAttrs('ok', sv.descr || '', sv.motore || '', sv.value || '', sv.kind || '');
    if (!id) { upd.then(function () { window.location.href = '/cart'; }); return; }
    upd.then(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty }) });
    }).then(function () { window.location.href = '/cart'; })
      .catch(function () { window.location.href = '/cart'; });
  }

  /* ---------- persistence ---------- */
  function readSaved() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function save(value, kind, descr, motore) {
    localStorage.setItem(KEY, JSON.stringify({ value: value, kind: kind, descr: descr, motore: motore || '' }));
    if (window.sdVBarRefresh) window.sdVBarRefresh();   // accende/aggiorna la barra veicolo sticky anche sul prodotto
  }

  /* ---------- cart attributes: la verifica entra dentro l'ordine ----------
   * Scrive attributi carrello (/cart/update.js) che persistono in
   * order.note_attributes → così a valle si fa l'analisi server-side
   * verify→purchase e si alimentano le offline conversions (gclid + valore).
   * IL GCLID È GIÀ COPERTO da snippets/gclid-capture.liquid (attributi
   * `gclid`/`gclid_ts`) → qui NON lo ri-scriviamo (niente duplicazione):
   * aggiungiamo SOLO il fatto della verifica, il veicolo e l'esito.
   * Nomi SENZA underscore = visibili nell'admin ordine (come i gclid già
   * presenti) → il venditore vede subito cosa ha verificato il cliente.
   * /cart/update.js fa MERGE delle chiavi: non tocca gli attributi gclid/utm
   * già scritti. Gli attributi si applicano al carrello corrente anche vuoto.
   * Ritorna la Promise del fetch così il chiamante può sequenziare (evita che
   * la navigazione al checkout abortisca la richiesta). */
  function verifyAttrs(outcome, descr, motore, plate, kind) {
    var veic = descr ? ('Iveco Daily ' + descr + (motore ? ' · ' + motore : '')) : '';
    // sd_match = classe di match dell'ultima verifica ('oe'|'anno'|'uni'|''): NON è PII, è la classe
    // di compatibilità. Serve alla sentinella resi per misurare i soli ordini GARANTIBILI (sd_match='oe').
    var attrs = { sd_verifica: 'si', sd_outcome: outcome || '', sd_match: lastMatch || '', sd_veicolo: veic };
    // TARGA/TELAIO del cliente nell'ordine (record aziendale come il form HubSpot: sappiamo il suo mezzo,
    // ce lo portiamo dove vogliamo — CRM, servizio, cross-sell). NB: dato personale → resta SOLO nell'ordine,
    // NON va mai a GA4/Ads (track() non lo include). Nome per tipo → visibile e chiaro nell'admin ordine.
    // DINAMICO: scrive il valore corrente e PULISCE il tipo opposto → l'ordine riflette
    // sempre l'ultimo mezzo verificato (se passa da targa a telaio non resta la vecchia targa).
    if (plate) { attrs.sd_targa = (kind === 'telaio') ? '' : plate; attrs.sd_telaio = (kind === 'telaio') ? plate : ''; }
    var cid = gaClientId(); if (cid) attrs.ga_client_id = cid;   // client_id GA4 nell'ordine → riconcilia acquisti↔sessioni lato server (Blocco 1)
    try {
      return fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }

  // Azzera gli attributi-verifica sul carrello (usato al "Cambia veicolo"/reset) → l'ordine
  // non porta un mezzo che il cliente ha rimosso. Non tocca gclid/utm/ga_client_id.
  function clearVerifyAttrs() {
    var attrs = { sd_verifica: '', sd_outcome: '', sd_match: '', sd_veicolo: '', sd_targa: '', sd_telaio: '' };
    try {
      return fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }

  function run(value, kind, opts) {
    opts = opts || {};
    lastValue = value;
    if (!opts.silent) { goBtn.disabled = true; goBtn.textContent = TT('Verifico…', 'verifying'); }
    track(opts.silent ? 'autocheck' : 'click', { method: kind });
    return ask(value, kind).then(function (res) {
      var oc = outcomeOf(res);
      lastOutcome = oc;
      var descr = (res && res.vehicle && res.vehicle.descr) || (opts.savedDescr || '');
      var motore = (res && res.vehicle && res.vehicle.motore) || '';
      if (oc !== 'unknown') {
        save(value, kind, descr, motore); showChip(descr);
        verifyAttrs(oc, descr, motore, value, kind);   // verifica riuscita → veicolo + TARGA/TELAIO nell'ordine
        if (!opts.silent) track('vehicle_set', { source: 'product', method: kind, outcome: oc });   // reach reale: solo su azione utente, non sui re-check silenziosi
      }
      render(oc, res, oc === 'unknown' ? 'not_found' : '');
      track('result', { outcome: oc, method: kind, silent: !!opts.silent });
      // Evento dedicato warn/unknown → D1 callback-sd (warn_events): quale prodotto×veicolo non dà ✓.
      sendWarnEvent(oc, oc === 'unknown' ? unknownReason(res) : 'not_in_config', res, opts.silent ? 'autocheck' : 'click', value, kind);
      if (!opts.silent) { goBtn.disabled = false; goBtn.textContent = TT('Verifica compatibilità', 'go'); }
      return oc;
    });
  }

  /* ---------- wire ---------- */
  if (goBtn) goBtn.addEventListener('click', function () {
    track('click');   // intento "verifica" (sostituisce il vecchio click_verifica_targa, ora rotto in GTM)
    var raw = input.value, np = normPlate(raw);
    // Rispetta il toggle scelto (Targa/Telaio).
    var mode = root.querySelector('.svt__tab[data-kind="telaio"].is-on') ? 'telaio' : 'targa';
    if (mode === 'telaio') {
      if (!isVin(np)) { var rzt = badReason(np, 'telaio'); render('unknown', null, rzt); track('badformat', { mode: 'telaio', reason: rzt }); sendWarnEvent('unknown', rzt, null, 'click', np, 'telaio'); return; }
      run(np, 'telaio'); return;
    }
    // Modo targa: se in realtà è un VIN valido, lo trattiamo comunque come telaio.
    if (isVin(np)) { run(np, 'telaio'); return; }
    if (!isPlate(np)) {
      if (isOldPlate(np)) { run(np, 'targa'); return; }   // targa vecchia: ora nell'indice → prova sul worker (se non trova, parte il campo telaio reattivo)
      var rzg = badReason(np, 'targa'); render('unknown', null, rzg); track('badformat', { mode: 'targa', reason: rzg }); sendWarnEvent('unknown', rzg, null, 'click', np, 'targa'); return;
    }
    run(np, 'targa');
  });
  if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') goBtn.click(); });

  // Toggle Targa / Telaio (guida l'input; il check comunque auto-rileva targa vs VIN)
  root.querySelectorAll('.svt__tab').forEach(function (t) {
    t.addEventListener('click', function () {
      root.querySelectorAll('.svt__tab').forEach(function (x) { x.classList.remove('is-on'); });
      t.classList.add('is-on');
      var eu = root.querySelector('.svt__eu');
      if (t.getAttribute('data-kind') === 'telaio') {
        input.maxLength = 17; input.placeholder = 'ZCFC1350...'; if (eu) eu.style.display = 'none';
      } else {
        input.maxLength = 10; input.placeholder = 'AB 123 CD'; if (eu) eu.style.display = '';
      }
      input.value = ''; try { input.focus(); } catch (e) {}
    });
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('.svt__reset')) { e.preventDefault(); resetVehicle(); }
    if (e.target.closest('.svt__atc')) { e.preventDefault(); addToCart(); }
    if (e.target.closest('.svt__show-assist')) { e.preventDefault(); assist.classList.add('is-on'); loadHsForm(); prefillHsTarga(); assist.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });

  /* ---------- estero: UI tradotta + modalità telaio forzata (IT invariato) ---------- */
  applyForeignI18n();

  /* ---------- auto-restore: veicolo ricordato PER SEMPRE finché non resetta ---------- */
  var saved = readSaved();
  if (saved && saved.value) {
    if (input) input.value = saved.value;
    showChip(saved.descr);
    run(saved.value, saved.kind || 'targa', { silent: true, savedDescr: saved.descr });
  }
})();
